import Http from '../Http'
import * as action from '../store/actions/auth'
import axios from "axios";
import {AUTH_ROUTES, CLIENTS_ROUTES} from "../config/routes";
import {getNews, getSites, show1Alert, showSuccess1Alert} from "./clientsService";
import {handleError, showFAlert, showSAlert} from "../utils/functions";
import {showAlert, showSuccessAlert, setTariffs} from "../store/actions/common";

export function login(credentials) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(AUTH_ROUTES.login, credentials)
                .then(res => {
                    if (res.status == 200 && !res.data.error) {
                        dispatch(action.authLogin(res.data));
                        dispatch(getBalance());

                    } else {
                        showFAlert('Ошибка', 'Неверные доступы', dispatch)
                    }

                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}


export function resetPassword(credentials) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post('../api/password/email', credentials)
                .then(res => {
                    return resolve(res.data);
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function updatePassword(credentials) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post('../../api/password/reset', credentials)
                .then(res => {
                    const statusCode = res.data.status;
                    if (statusCode == 202) {
                        const data = {
                            error: res.data.message,
                            statusCode,
                        }
                        return reject(data)
                    }
                    return resolve(res);
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function register(credentials) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(AUTH_ROUTES.register, credentials)
                .then(res => {
                    if (res.status == 200 && !res.data.error) {
                        showSAlert('Успех', res.data.message, dispatch)
                    } else {
                        showFAlert('Ошибка', res.data.error, dispatch)
                    }

                    dispatch(getBalance());
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function changePassword(oldPassword, newPassword) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(AUTH_ROUTES.changePassword, {oldPassword, newPassword})
                .then(res => {

                    if (res.status == 200 && !res.data.error) {
                        dispatch(action.changePassword(res));
                        showSAlert('Успех', 'Пароль успешно изменен', dispatch)
                    } else {
                        showFAlert('Ошибка', res.data.message, dispatch)
                    }
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export function forgotPassword(email) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(AUTH_ROUTES.forgotPassword, {email})
                .then(res => {

                    if (res.status == 200 && !res.data.error) {
                        showSAlert('Успех', 'Инструкции по сбросу пароля отправлены на почту. Проверьте входящие сообщения', dispatch)
                    } else {
                        showFAlert('Ошибка', res.data.error, dispatch)
                    }
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}
export  function logout() {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.post(AUTH_ROUTES.logout)
                .then(res => {
                    dispatch(action.authLogout());
                    window.localStorage.removeItem('jwt_token');
                    window.localStorage.removeItem('persist:root');
                    window.localStorage.removeItem('is_admin');
                    showSAlert('Успех', 'Вы успешно вышли из системы', dispatch)
                    return resolve();
                })
                .catch((err) => handleError(err, reject, dispatch))
        })
    )
}

export  function getBalance() {
    return dispatch => (
        new Promise((resolve, reject) => {
            dispatch(getNews());
            dispatch(getSites());
            Http.get(AUTH_ROUTES.balance)
                .then(res => {
                    dispatch(action.authBalance(res.data))
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })
    )
}

export function getPayments(params = {}) {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.get(AUTH_ROUTES.getPayments, {params})
                .then(res => {
                    dispatch(action.setPayments(res.data))
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })
    )
}
export  function getTariffs() {
    return dispatch => (
        new Promise((resolve, reject) => {
            Http.get(AUTH_ROUTES.getTariffs)
                .then(res => {
                    dispatch(setTariffs(res.data))
                    return resolve();
                })
                .catch((err) => handleError(err, reject))
        })
    )
}

export function getPaymentData(amount) {
    return Http.post(CLIENTS_ROUTES.paymentData, {amount: amount})
}
